/*
 * Scenario: insert-at-start
 *
 * Schlaegt einen neuen Absatz vor dem ersten Paragraphen vor — afterParagraphId
 * ist explizit null. Damit testen wir den Edge-Case "Insert am Dokumentanfang"
 * im EditorView (_applyReviewInserts: insertAt=0) und in
 * EditorModel.insertParagraphAfter(null).
 */

import { emit, wait } from './_helpers.js'

export const name = 'insert-at-start'
export const description = 'Insert a new paragraph at the very start (afterParagraphId=null).'

export async function run(state) {
    const toolCallId = 'tu_ins_start_' + Date.now().toString(36)

    await emit(state, 'session', { sessionId: 'mock-insert-start' }, 0)
    await emit(state, 'thinking', { text: 'A short prologue might frame this better…' }, 250)
    await emit(state, 'thinkingDone', {}, 200)

    await emit(state, 'proposeInsert', {
        toolCallId,
        afterParagraphId: null,
        // Kein baseVersion sinnvoll fuer einen Anker, der "vor allem" liegt.
        newText: 'Before any of it began, there was a quiet morning. The kind that hides what comes next.',
        reason: 'Establishes the calm-before-the-storm contrast.'
    }, 400)
    await emit(state, 'done', { usage: {} }, 200)

    try {
        const info = await wait(state, toolCallId, 5 * 60 * 1000)
        const reaction = info.result === 'applied'
            ? 'Added the prologue. Want me to look at the rest?'
            : 'Okay, no prologue. The opening stays as it is.'
        await emit(state, 'delta', { text: reaction }, 300)
        await emit(state, 'done', { usage: {} }, 100)
    } catch { /* abort */ }
}
